module.exports = __webpack_public_path__ + "img/doc.4d2c7d70.svg";